var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "multi-ratio-cover" }, _vm._l(_vm.coverGroup, function (cover) {
    return _c('div', { key: cover.value, staticClass: "multi-container" }, [_c('span', { staticClass: "label" }, [_vm._v(_vm._s(cover.label))]), _vm._v(" "), _vm._l(cover.children, function (item) {
      return _c('div', { key: item, staticClass: "upload-selector" }, [_c('upload-image', { attrs: { "cover": cover, "item": item, "maxSize": _vm.maxSize, "accepts": _vm.accepts }, on: { "previews": _vm.getCoverPreviews } })], 1);
    })], 2);
  }), 0);
};
var staticRenderFns = [];

export { render, staticRenderFns };